export enum EnumViewType {
    WINDOW = 'window',
    WIDGET = 'widget',
}
